import styles from './SignalPerks.scss';
import classNames from 'classnames';
import BundleType from '~/components/BundleType/BundleType';

interface ISignalPerks {
    item: IItemCommonData;
}

export const SIGNAL_BATTLE_TAG = 'Battle';
export const SIGNAL_ECO_TAG = 'Eco';

const SignalPerks = (props: ISignalPerks): any => {
    return (
        <div className={styles.wrapper}>
            <div className={classNames(styles.signal, styles.icon)}>
                <BundleType item={props.item} />
            </div>
        </div>
    );
};

export default SignalPerks;
